import { createAction } from '@shared/modules/event-bus/utils/create-action.util';
import { headerActionTypes } from '@shared/modules/header/actions/header.action-types';
import { ExportDataFormat } from '@shared/classes/ExportDataFormat';

export default {
  newEntityButtonClickAction: () => createAction(headerActionTypes.newEntityButtonClick),
  exportTableButtonClickAction: () => createAction(headerActionTypes.exportTableButtonClick),
  exportData: (payload: ExportDataFormat) => createAction(headerActionTypes.exportData, payload),
};
